<template>
  <div class="border-t border-primary-400 text-neutral-50 p-5">
    <p class="text-xl font-semibold mb-2">Free Workspace</p>
    <p class="mb-2">{{ projects?.length }} / 3 projects used</p>
    <div class="text-sm mb-4">
      <UpgradeModal>
        <template #trigger>
          <Button variant="link" class="p-0 h-auto font-normal">Upgrade</Button>
        </template>
      </UpgradeModal>
      to get unlimited items, projects, larger uploads and more.
    </div>
    <a target="_blank" href="/pricing">
      <Button variant="outline" size="sm">
        <Info class="h-4 w-4" /> Learn More
      </Button>
    </a>
  </div>
</template>

<script setup>
import { useQuery } from '@tanstack/vue-query';
import { Info } from 'lucide-vue-next';

import { Button } from '@ui/components/button';
import { UpgradeModal } from '@components/common/UpgradeModal';
import { queries } from '@/queries/index.js';

const { data: projects } = useQuery(queries.workspace.projects);
</script>
